/**
 * Facebook (Meta) lead source field identity helpers.
 *
 * Meta returns `type` as the Meta enum (PHONE, EMAIL, ..., CUSTOM) and the
 * info types (CREATED_UNIX_TIME, ...). Advertiser questions all share
 * `type: "CUSTOM"`, so they can only be told apart by their question `key`.
 *
 * Identity rule:
 *   - type !== CUSTOM -> identity is the type token (PHONE, CREATED_UNIX_TIME, ...)
 *   - type === CUSTOM -> identity is the question key
 */
export const FB_CUSTOM_TYPE = "CUSTOM";

const toStr = (value) =>
    value === null || value === undefined ? "" : value.toString();

export const isFacebookCustomType = (type) =>
    toStr(type).toUpperCase() === FB_CUSTOM_TYPE;

/**
 * @param {{ type?: any, key?: any } | null | undefined} field
 * @returns {string}
 */
export const getFacebookSourceIdentity = (field) => {
    if (!field) return "";
    const type = toStr(field.type);
    const key = toStr(field.key);
    if (type === "" || isFacebookCustomType(type)) {
        return key;
    }
    return type;
};
